<template>
	<BModal id="cleanHomesFeesModal"
		title="Confirm Fees"
		centered
		size="xl" no-footer>
		<BOverlay :show="loading">
			<template v-if="stage === 'initial'">
				You are creating your invoice for the services you have selected which
				will be paid, in due course, to bank account
				<strong>BSB</strong> {{ padString(user.bsb) }}
				<strong>Account Number</strong> {{ user.bank_account_number }}.

				When you claim payment for jobs done, Clean Homes confirms the job was completed and on-charges
				the service.
				It is unlawful to claim payment for services which have not been completed.

				<div v-if="requiresStatementOrAbn" class="mt-3">
					<p>
						<strong>You have not provided an ABN or signed a <i>Statement by a Supplier</i>.</strong>
					</p>
					<p>
						Please choose from the following:
					</p>
					<BButton class="rounded-05" @click="stage = 'abn'">
						Provide ABN
					</BButton>
					<BButton class="rounded-05" @click="stage = 'statement'">
						Provide Statement by a Supplier
					</BButton>
				</div>
				<div v-else class="mt-3">
					<BButton class="rounded-05"
						variant="primary"
						@click="submit">
						Submit
					</BButton>
				</div>
			</template>
			<template v-if="stage === 'abn'">
				<a-b-n-form @submitted="onAbnComplete"></a-b-n-form>

				<div class="mt-3">
					<BButton variant="primary" class="rounded-05"
						@click="stage = 'initial'">
						Go Back
					</BButton>
				</div>
			</template>
			<template v-if="stage === 'statement'">
				<docuseal-embedded-form src="https://docuseal.co/d/5Z1DDk41g3FjBw"
					:email="user.email"
					:values="docusealValues"
					:external-id="documentId"
					@complete="onStatementComplete"></docuseal-embedded-form>
			</template>
		</BOverlay>
	</BModal>
</template>

<script>
	import ABNForm from '@js/components/my/ABNForm.vue';
	import DocusealEmbeddedForm from '@js/components/helpers/DocusealEmbeddedForm.vue';
	import {axios} from '@js/utilities/axios.js';
	import { v4 as uuidv4 } from 'uuid';

	export default {
		name: 'CleanHomesFeesModal',
		components: {DocusealEmbeddedForm, ABNForm},
		emits: ['submit'],
		data () {
			return {
				stage: 'initial',
				loading: false,
				documentId: uuidv4(),
			}
		},
		computed: {
			user() {
				return this.$store.getters['auth/user'];
			},
			requiresStatementOrAbn() {
				return !this.user.abn && !this.user.statement_by_supplier_signed_at;
			},
			docusealValues() {
				return {
					'Name 1': this.user.name,
					'Name 2': '',
					'Address 1': this.user.address,
					'Address 2': '',
					'Suburb': this.user.suburb,
					'State': this.user.state,
					'Postcode': this.user.postcode,
					'Name of Supplier': this.user.name,
					'Phone': this.user.phone || '',
					'Date': moment().format('YYYY-MM-DD'),
					'6': true,
				}
			}
		},
		methods: {
			open() {
				this.stage = 'initial'
				this.$bvModal.show('cleanHomesFeesModal');
			},
			submit () {
				this.$bvModal.hide('cleanHomesFeesModal');
				this.$emit('submit');
			},
			padString(value) {
				if (!value) return;
				return value.toString().padStart(6, '0');
			},
			onAbnComplete() {
				toastr.success('ABN has been successfully updated');
				this.loading = true
				this.$store.dispatch('auth/fetchUser').then(() => {
					this.loading = false
					this.stage = 'initial'
				})
			},
			onStatementComplete(ctx) {
				toastr.success('Statement by a Supplier has been signed and submitted');
				this.loading = true

				axios.post('/api/user/statement-by-supplier', {submission_id: ctx.submission_id})
					.then(() => {
						this.$store.dispatch('auth/fetchUser').then(() => {
							this.loading = false
							this.stage = 'initial'
						})
					})
					.catch(() => {
						toastr.error('Failed to update statement by a supplier')
						this.loading = false
					})
			}
		}
	}
</script>

<style scoped>

</style>
